<template>
  <div class="p-5">
      <div class="row mb-2">
        <div class="col-md-6">
          <h2 class="title-news">{{$t('label.novidades')}}</h2>
        </div>
        <div class="col-md-6 text-right">
          <div
            class="btn-group btn-group-toggle btn-news"
            data-toggle="buttons"
          >
            <button
                    :disabled="page == 0"
              class="btn btn-secondary btn-sm active"
              @click="onNavigate(true)"
            >
              <i class="material-icons">
                keyboard_arrow_left
              </i>
            </button>
            <button
                    :disabled="page == maxPage"
              class="btn btn-secondary btn-sm"
              @click="onNavigate(false)"
            >
              <i class="material-icons">
                keyboard_arrow_right
              </i>
            </button>
          </div>
        </div>
      </div>
      <div class="card mb-3" v-for="item in feedShow">
            <div class="row no-gutters">
                <div class="col-md-4">
                    <img class="card-img" style="width: 100%;height: 100%;" :alt="item.title" :src="item.imgSrc" v-if="item.imgSrc">
                    <img class="card-img" style="width: 100%;height: 100%;" :alt="item.title" :src="defaultImage" v-else>
                </div>
                <div class="col-md-8">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-7">
                                <h5 class="card-title card-title-news">{{item.title}}</h5>
                            </div>
                            <div class="col-md-5" style="height: calc(125px - 1.25rem);">
                                <span v-for="categoria in item.categories" v-bind:key="categoria" class="badge badge-pill badge-secondary px-3 float-right">
                                    <h6 class="m-0 font-weight-lighter">{{categoria}}</h6>
                                </span>
                                <a :href="item.link" class="text-decoration-none float-right" style="position: absolute;bottom: 0;right: 15px;">LEIA MAIS</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
      </div>
    <div v-if="!loaded">
      {{ $t("label.carregando") }}
    </div>
  </div>
</template>
<script>
import Parser from "rss-parser";

/**
 * Componente para ler rss e renderizar as notivias
 */
export default {
  name: "RssReader",
  props: {
    /**
    * Imagem que irá carregar caso ocorra algum erro.
    */
    defaultImage: {
        type: String,
    },
    /**
     * Url do feed
     */
    url: {
      type: String
    },
    /**
     * Feed em string
     */
    feedData: {
      type: String
    },
    /**
     * Maximo de items exibidos
     */
    pageSize:{
      type: Number,
      default: 3
    }
  },
  watch: {
    url() {
      this.readFeed();
    },
    feedData() {
      this.readFeed();
    }
  },
  data() {
    return {
      feed: [],
      feedShow: [],
      page: 0 ,
      maxPage: 0 ,
      loaded: false
    };
  },
  methods: {
    async readFeed() {
      const parser = new Parser();
      if (this.url) {
        this.feed = await parser.parseURL(this.url);
      } else if (this.feedData) {
        this.feed = await parser.parseString(this.feedData);
      }
      this.loaded = true;

      if( this.feed.items ) {
        var rx = /<img.*?src="(.*?)".*?>/g;
        this.feed.items.forEach( ( item ) => {
            const match = rx.exec(item.content)
          if( match && match.length > 0) {
            item.imgSrc = match[1]
          }
        })

        this.maxPage = Math.ceil(this.feed.items.length / this.pageSize)-1;
        this.onNavigate()
      }
    },
    onNavigate(left) {
      if (this.feed && this.feed.items) {
        if (left === true) {
          if (this.page == 0) {
            this.page = 0;
          }else{
            this.page = this.page-1;
          }
        }else if ( left ===false ) {
          if( this.page != this.maxPage){
           this.page = this.page+1;
          }
        }
        const indexMin = this.page*this.pageSize
        const indexMax = indexMin + this.pageSize

        this.feedShow = this.feed.items.filter(
          (x, index) => index >= indexMin && index < indexMax
        )
        console.log( this.feedShow )
      }
    }
  },
  mounted() {
    this.readFeed()
  }
};
</script>
<style>
.feedItem {
  float: left;
}
.feedItem a img {
  width: 30px;
  height: 30px;
}
</style>
